<script>
import {mixin_clearPhoneNumShow, mixin_page_table} from "@/utils/mixin";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {usual_visitor_sign_mixin} from "@/pages/helper/usual_visitor_mixin";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import ApplyShowDetailDrawer from "@/components/ApplyShowDetailDrawer.vue";
import RecordShowDetailDrawer from "@/components/RecordShowDetailDrawer.vue";
import {getRecordList, getTodayRecordTotal, signLeaveBatch, usualVisitorSignLeave} from "@/api/record-api";
import {getDataYMD} from "@/utils/commonUtils";
import {getAllArea} from "@/api/device-manager-api";
import PrintView from "@/pages/guard/PrintView.vue";
import {aesEnc} from "@/utils/cryptoUtils";

export default {
  name: "VisitorTotalPage",
  components: {PrintView, RecordShowDetailDrawer, ApplyShowDetailDrawer, MyNotifyDialog, ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow, usual_visitor_sign_mixin],

  data() {
    return {
      todayTotal: {
        signEnter: 0,
        signLeave: 0,
        stay: 0,
      },

      arriveFormSearch: {
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
        visitorCarNo: "",
        visitorCardNo: "",
        withCar: "",
        isDriverCar: "",
      },

      searchParams: {},

      pickerOptions: {
        selectableRange: '00:00:00-23:59:59', // 设置可选的时间范围
        format: 'HH:mm' // 设置时间显示格式
      },
      defaultProps: {
        children: "departments",
        label: "name",
      },
      areaProps: {
        children: "areas",
        label: "name",
      },

      withCarOptions: [
        {value: "ALL", label: "全部"},
        {value: "YES", label: "有车"},
        {value: "NO", label: "无车"},
      ],
      visitStatusApply: [
        {value: "ALL", label: "全部"},
        {value: "NO", label: "未到"},
        {value: "ENTER", label: "已到"},
      ],
      visitStatus: [
        {value: "ALL", label: "已签到"},
        {value: "ENTER", label: "未签离"},
        {value: "LEAVE", label: "已签离"},
      ],

      areaTree: [],
      areaMap: {},

      tableColumnListTypeC: [
        {prop: "visitorType", label: "访客类型", width: 100, type: 3},
        {prop: "visitorName", label: "访客姓名", width: 90, type: 0},
        {prop: "visitorPhoneNo", label: "访客手机", width: 120, type: 9},
        {prop: "fullEnterTime", label: "到访时间", width: 140, type: 0},
        {prop: "fullLeaveTime", label: "离开时间", width: 140, type: 0},
        {prop: "enterCarNum", label: "车牌号码", type: 0},
        {prop: "enterCardNo", label: "访客卡号", type: 0},
        {prop: "enterSuperAreaName", label: "签到区域", type: 0},
        {prop: "enterSubAreaName", label: "签到子区域", type: 0},
        {prop: "completeState", label: "到访状态", width: 80, type: 2},
        // {prop: "param14", label: "操作", width: 150, type: 103},
      ],


      notify: {
        title: "",
        show: false,
        success: false,
        msg: ""
      },
      printInfo: {
        visitorName: "",
        visitorCount: 1,
        visitorCompany: "",
        visitorPhone: "",
        visitorReason: "",
        visitorCarNo: "",
        visitorCountry: "",
        enterArea: "",
        employeeDepartment: "",
        employeeName: "",
        enterTime: "",
        leaveTime: "",
        employeeSign: "",
        guardSign: "",
        qrCode: "",
        visitorCardNo: "",
        isProvider: false,
        saveArea: "", // 存放区域， 填卡号
      },

    }
  }, // end data

  mounted() {
    this.getTotalData()
    let nowDay = getDataYMD(new Date())
    this.arriveFormSearch.dateArea = [nowDay, nowDay]
    this.onSearchClick()
    this.setupAreaData()

  },

  methods: {
    getTotalData() {
      let areaIds = [this.$store.state.loginInfo.areaId]
      getTodayRecordTotal(areaIds).then(({data}) => {
        if (data.code === 200) {
          this.todayTotal.signEnter = data.data.checkInNum
          this.todayTotal.stay = data.data.onlineNum
          this.todayTotal.signLeave = data.data.checkOutNum
        } else {
          console.log("getTodayRecordTotal err", data)
        }
      }).catch((err) => {
        console.error("getTodayRecordTotal err", err)
      })
    },

    onSearchClick() {
      this.refreshSearchParam()
      this.curPageIndex = 1
      this.refreshTableData()
    },

    refreshSearchParam() {
      let params = {}
      if (this.arriveFormSearch.visitorName) {
        params.visitorName = this.arriveFormSearch.visitorName
      }
      if (this.arriveFormSearch.visitorPhoneNo) {
        params.visitorTel = this.arriveFormSearch.visitorPhoneNo
      }

      if (this.arriveFormSearch.visitStatus && this.arriveFormSearch.visitStatus !== "ALL") {
        params.arrived = this.arriveFormSearch.visitStatus
      }
      if (this.arriveFormSearch.dateArea && this.arriveFormSearch.dateArea.length > 1) {
        params.beginDate = this.arriveFormSearch.dateArea[0]
        params.endDate = this.arriveFormSearch.dateArea[1]
      }
      if (this.arriveFormSearch.startTime || this.arriveFormSearch.endTime) {
        params.beginTime = this.arriveFormSearch.startTime ? this.arriveFormSearch.startTime + ":00" : "00:00:00"
        params.endTime = this.arriveFormSearch.endTime ? this.arriveFormSearch.endTime + ":59" : "23:59:59"
      }
      if (this.arriveFormSearch.visitorCarNo) {
        params.enterCarNum = this.arriveFormSearch.visitorCarNo
      }
      if (this.arriveFormSearch.visitorCardNo) {
        params.enterCardNo = this.arriveFormSearch.visitorCardNo
      }
      if (this.arriveFormSearch.isDriverCar) {
        params.isDriverCar = this.arriveFormSearch.isDriverCar === "1"
      }
      let areaId = this.$store.state.loginInfo.areaId
      params.enterAreaIds = [areaId]
      // params.leaveAreaIds = [areaId]
      this.searchParams = params
    },

    setupAreaData() {
      getAllArea().then(({data}) => {
        if (data.code === 200) {
          this.areaTree = data.data
          this.areaMap = {}
          this.areaTree.forEach(item => {
            this.areaMap[item.id] = item
            ;(item.areas || []).forEach(subItem => {
              this.areaMap[subItem.id] = subItem
            })
          })
        } else {
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log("doGetAllArea err", err)
        this.showNetErrMsg()
      })
    },


    refreshTableData() {
      const pageData = {
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      const searchParam = this.searchParams
      const postData = Object.assign(pageData, searchParam)
      getRecordList(postData).then(({data}) => {
        this.tableData = []
        if (data.code === 200 && data.data && data.data.data) {
          this.totalCount = data.data.totals
          data.data.data.forEach(item => {
            let area = this.areaMap[item.enterAreaId]
            let areaName = ""
            let superAreaName = ""
            if (area) {
              if (area.parentId > 0) {
                let superArea = this.areaMap[area.parentId]
                if (superArea) {
                  superAreaName = superArea.name
                }
                areaName = area.name
              } else {
                superAreaName = area.name
              }
            }
            item.visitorType = item.type === "USUAL" ? "常访访客" : "普通访客"
            item.visitorName = item.visitor.name
            item.visitorPhoneNo = item.visitor.tel
            item.enterSuperAreaName = superAreaName
            item.enterSubAreaName = areaName
            item.fullEnterTime = ""
            item.fullLeaveTime = ""
            if (item.enterDate && item.enterTime) {
              item.fullEnterTime = item.enterDate + " " + item.enterTime.substring(0, 5)
            }
            if (item.leaveDate && item.leaveTime) {
              item.fullLeaveTime = item.leaveDate + " " + item.leaveTime.substring(0, 5)
            }
          })
          this.tableData = data.data.data
        }
      })

    },

    onResetSearch() {
      let nowDay = getDataYMD(new Date())

      this.arriveFormSearch = {
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [nowDay, nowDay],
        startTime: "",
        endTime: "",
        visitorCarNo: "",
        visitorCardNo: "",
      }
      this.onSearchClick()
    },

    addAdminHandleNodeClick(data, node, item) {
      console.log("addAdminHandleNodeClick", data, node, item)
      this.applyFormSearch.department = data.name
    },

    areaNodeEnterClick(data, node, item) {
      console.log("areaNodeEnterClick", data, node, item)
      this.arriveFormSearch.enterArea = data.name
      this.arriveFormSearch.enterAreaId = data.id
    },

    areaNodeLeaveClick(data, node, item) {
      console.log("areaNodeLeaveClick", data, node, item)
      this.arriveFormSearch.leaveArea = data.name
      this.arriveFormSearch.leaveAreaId = data.id
    },

    async onSelectChange() {
      console.log("onSelectChange", this.arriveFormSearch)
    },

    tableShow1(rowData) {
      this.$refs.applyDetailDrawer.showApplyDetail(rowData)
    },

    tableShow2(row) {
      this.$refs.recordDetailDrawer.showRecordDetail(row)
    },

    signLeaveUsual(visitor, arriveId) {
      console.log("signLeaveUsual")
      let postData = {
        recordIds: [arriveId],
        leaveDeviceId: "",
        leaveAreaId: "",
      }
      usualVisitorSignLeave(postData).then(({data}) => {
        if (data.code === 200) {
          this.notifyUsualVisitorSignLeaveResult(visitor, true, "签离成功")
          this.refreshTableData()
        } else {
          this.notifyUsualVisitorSignLeaveResult(visitor, false, "签离失败")
        }
      }).catch(() => {
        this.notifyUsualVisitorSignLeaveResult(visitor, false, "签离失败")
      })
    },

    signLeaveNormal(recordIds) {
      let areaId = this.$store.state.loginInfo.areaId
      let postData = {
        recordIds: recordIds,
        leaveAreaId: areaId,
        leaveGuardName: "",
      }
      signLeaveBatch(postData).then(({data}) => {
        console.log("signLeaveBatch", data)
        if (data.code === 200) {
          this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
          this.autoCloseTimer = setTimeout(() => {
            this.autoCloseTimer = null
            this.onSignDialogClose()
          }, 2000)
          this.refreshTableData()
        } else if (data.code === 720) {
          this.notify = {title: "签离结果", show: true, success: false, msg: "未同意签离或者签离超时"}
          this.logE("VisitCodeCome signEnter false", data.code, data.msg)
        } else {
          this.notify = {title: "签离结果", show: true, success: false, msg: "签离失败",}
          this.logE("VisitCodeCome signEnter false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome signEnter err", err)
        this.notify = {title: "签离结果", show: true, success: false, msg: "签离失败, 网络异常",}
      })
    },

    signLeave(row) {

      if (row.type === "USUAL") {
        this.signLeaveUsual(row.visitor, row.id)
      } else {
        let recordIds = [row.id]
        this.signLeaveNormal(recordIds, row.enterDate)
      }
    },

    onSignDialogClose() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
      this.notify.show = false
    },
    doRePrint(row) {
      console.log("doRePrint ", row)
      if (row.type === "USUAL") {
        let visitor = row.visitor
        let employee = row.employee

        let reason = ""
        let msg = {type: "visitor", code: visitor.code}
        let qrCodeStr = aesEnc(JSON.stringify(msg))
        this.printInfo.visitorName = visitor.name
        this.printInfo.visitorCount = "1"
        this.printInfo.visitorCompany = visitor.company
        this.printInfo.visitorPhone = visitor.tel
        this.printInfo.visitorReason = reason
        this.printInfo.visitorCarNo = visitor.car
        this.printInfo.visitorCountry = visitor.nationality
        this.printInfo.isProvider = visitor.type === "provider"
        this.printInfo.visitorCardNo = visitor.cardNo

        this.printInfo.guardSign = ""
        this.printInfo.employeeName = employee ? employee.name : ""
        this.printInfo.employeeDepartment = employee ? employee.departmentName : ""
        this.printInfo.employeeSign = ""

        this.printInfo.enterArea = ""
        this.printInfo.enterTime = row.enterDate ? row.enterDate + " " + row.enterTime : ""
        this.printInfo.leaveTime = row.leaveDate ? row.leaveDate + " " + row.leaveTime : ""
        this.printInfo.qrCode = qrCodeStr
        this.printInfo.saveArea = visitor.cardNo

      } else {
        let reasonRow = row.apply.forms.find(item => item.name === "reason")
        let reason = reasonRow ? reasonRow.value : ""
        let visitor = row.visitor
        let employee = row.employee
        let msg = {type: "visitor", code: visitor.code}

        this.printInfo.visitorName = visitor.name
        this.printInfo.visitorCount = "1"
        this.printInfo.visitorCompany = visitor.company
        this.printInfo.visitorPhone = visitor.tel
        this.printInfo.visitorReason = reason
        this.printInfo.visitorCarNo = row.enterCarNum
        this.printInfo.visitorCountry = visitor.nationality
        this.printInfo.isProvider = visitor.type === 'provider'
        this.printInfo.visitorCardNo = row.enterCardNo

        this.printInfo.guardSign = ""
        this.printInfo.employeeName = employee.name
        this.printInfo.employeeDepartment = employee.departmentName
        this.printInfo.employeeSign = ""

        this.printInfo.enterArea = ""
        this.printInfo.enterTime = row.enterDate ? row.enterDate + " " + row.enterTime : ""
        this.printInfo.leaveTime = row.leaveDate ? row.leaveDate + " " + row.leaveTime : ""
        this.printInfo.qrCode = row.pinCode
        this.printInfo.saveArea = row.enterCardNo
      }
      this.$refs.printView.setPrintInfo(this.printInfo)
      setTimeout(() => this.$refs.printView.startPrint(), 150)


    },
  },// end methods

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "state") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "arrived") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else if (prop === "completeState") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
  }

}
</script>

<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onSignDialogClose"></my-notify-dialog>

    <ApplyShowDetailDrawer drawer-title="详细信息" :areaMap="areaMap" ref="applyDetailDrawer" :phoneNumShow="phoneNumShow"/>
    <RecordShowDetailDrawer drawer-title="详细信息" :area-map="areaMap" ref="recordDetailDrawer" :phoneNumShow="phoneNumShow"></RecordShowDetailDrawer>

    <div class="total-radio w-full flex">
      <div class="w-1/3">
        <div class="text-center h-12 flex items-center justify-between bg-blue rounded-l-md border border-gray-400 text-2xl px-1.5">
          <div class="text-red-600 font-bold">今日数据</div>
          <div><span class=" pr-1">签到人数： </span><span>{{ todayTotal.signEnter }}</span></div>
          <div></div>
        </div>
      </div>
      <div class="w-1/3 ">
        <div class="text-center h-12 flex items-center justify-center bg-blue  border-gray-300">
          <div class="text-2xl pr-1">签离人数：</div>
          <div class=" text-2xl">{{ todayTotal.signLeave }}</div>
        </div>
      </div>
      <div class="w-1/3 ">
        <div class="text-center h-12 flex  items-center justify-center bg-blue rounded-r-md border border-gray-400">
          <div class="text-2xl pr-1">在园访客：</div>
          <div class=" text-2xl">{{ todayTotal.stay }}</div>
        </div>
      </div>
    </div>
    <div class="pt-2 flex flex-row justify-start items-start border-t  search-box">
      <el-form label-width="95px " :model="arriveFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="访客姓名">
          <el-input v-model="arriveFormSearch.visitorName" placeholder="请输入访客姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
              class="my-date-picker"
              v-model="arriveFormSearch.dateArea"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="访客卡号">
          <el-input v-model="arriveFormSearch.visitorCardNo" placeholder="请输入访客卡号" clearable></el-input>
        </el-form-item>

      </el-form>

      <el-form label-width="95px " :model="arriveFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="访客手机">
          <el-input v-model="arriveFormSearch.visitorPhoneNo" placeholder="请输入访客手机" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-time-picker style="margin-right: 10px"
                          class="my-time-select"
                          placeholder="起始时间"
                          value-format="HH:mm"
                          format="HH:mm"
                          v-model="arriveFormSearch.startTime"
                          :picker-options="pickerOptions">
          </el-time-picker>
          <el-time-picker
              class="my-time-select"
              placeholder="结束时间"
              v-model="arriveFormSearch.endTime"
              value-format="HH:mm"
              format="HH:mm"
              :picker-options="pickerOptions">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="是否开车">
          <el-select class="my-date-picker" v-model="arriveFormSearch.isDriverCar" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <el-form label-width="95px " :model="arriveFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="到访情况">
          <el-select class="my-select" v-model="arriveFormSearch.visitStatus" clearable>
            <el-option v-for="item in visitStatus" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号码">
          <el-input v-model="arriveFormSearch.visitorCarNo" placeholder="请输入访客车牌号码" clearable style="width: 100%"></el-input>
        </el-form-item>
        <div class="button-area">
            <span>
                 <el-button type="primary" @click="onSearchClick">查询</el-button>
                <el-button type="success" plain @click="onResetSearch">重置</el-button>
            </span>
          <span>
            <el-button type="danger" plain style="margin-left: 50px" @click="cleartextShow('访客记录')">
              明文查看
            </el-button>
            </span>
        </div>
      </el-form>
    </div>

    <el-table :data="tableData" class="" key="tableColumnListTypeC" border stripe>
      <el-table-column v-for="(headerItem) in tableColumnListTypeC" :key="headerItem.prop" :prop="headerItem.prop" :label="headerItem.label" :width="headerItem.width" align="center">
        <template v-slot="scope">
          <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
          <template v-else-if="headerItem.type === 1">
            {{ scope.row[headerItem.prop] | tableDateFilter(headerItem.prop) }}
          </template>
          <el-tag v-else-if="headerItem.type === 2">{{
              scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
            }}
          </el-tag>
          <el-tag v-else-if="headerItem.type === 3">{{ scope.row[headerItem.prop] }}</el-tag>
          <template v-else-if="headerItem.type === 9">
            <template v-if="phoneNumShow">
              {{ scope.row[headerItem.prop] }}
            </template>
            <template v-else>
              {{ scope.row[headerItem.prop] | phNoFilter }}
            </template>
          </template>
          <template v-else> {{ scope.row[headerItem.prop] }}</template>
        </template>
      </el-table-column>
      <el-table-column label="签离" width="90" align="center">
        <template v-slot="scope">
          <el-button size="small" type="danger" @click="signLeave(scope.row)" :disabled="scope.row.completeState === 'LEAVE'">{{ scope.row.completeState === "LEAVE" ? '已签离' : '签离' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="打印" width="110" align="center">
        <template v-slot="scope">
          <el-button size="small" type="primary" @click="doRePrint(scope.row)">重新打印</el-button>
        </template>
      </el-table-column>
      <el-table-column label="查看" width="80" align="center">
        <template v-slot="scope">
          <el-button size="small" type="primary" @click="tableShow2(scope.row)">查看</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="pager">
      <el-pagination layout="total, sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                     :page-size.sync="curPageSize" :pager-count="5"
                     :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <PrintView ref="printView"/>
  </div>
</template>

<style scoped lang="less">

.bg-blue {
  background: #409EFF
}

.total-radio {

  /deep/ .el-radio-button__inner {
    width: 100%;
  }

  .first {
    /deep/ .el-radio-button__inner {
      border-radius: 8px 0 0 8px;
    }
  }

  .last {
    /deep/ .el-radio-button__inner {
      border-radius: 0 8px 8px 0;
    }
  }

  /deep/ .el-radio-button__inner {
    background-color: #f5f7fa;
  }

}

/deep/ .el-collapse-item__header {
  padding: 0;
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

/deep/ .el-collapse-item__wrap {
  background-color: #f5f7fa;
}

.demo-form-inline {
  width: 33%;

  .el-input {
    width: calc(100% - 50px);
  }

  .el-select {
    width: calc(100%);
  }

  .my-date-picker {
    width: calc(100% - 50px);
  }

  .my-time-select {
    width: calc(50% - 30px);
  }

  .button-area {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding-right: 50px;

  }
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

.drawer-content {

  .drawer-title {
    margin-left: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 380px;
  }

  .grid-content {
    //padding: 20px;

    margin: 8px 8px 8px 20px;
  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
    //text-align: right;
    //margin-right: 8px;

  }

  .input-description-long {
    display: inline-block;
    width: 120px;
    //text-align: right;
    //margin-right: 8px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  background-color: #efefef;
  line-height: 270px;
  text-align: center;
}


/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  //background-color: #ff0000;
  background-color: #409EFF;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409EFF;
}

.my-date-picker /deep/ .el-range-separator {
  min-width: 22px;
}

.search-box {
  /deep/ .el-form-item__label {
    font-size: 20px;
  }

  .el-input {
    font-size: 20px;
  }

  /deep/ .el-input__inner {
    font-size: 20px;

  }

  /deep/ .el-radio__label {
    font-size: 20px;
  }

  /deep/ .el-date-editor .el-range-input {
    font-size: 20px;
  }
}
</style>
